<div class="search-history">
    <div *ngIf="searchHistory && searchHistory.length > 0">
        <div *ngFor='let search of searchHistory' class="item-hover">
            <div class="section">
                <div class="row" style="margin:0px">
                    <div class="col-sm-7 text-left">
                        <div class="truncate"><span class="main-label" title="{{search.qs}}">{{search.qs}}</span></div>
                        <div><span class="sub-label">{{LOCALIZATION.results}}: </span>{{search.total}}</div>
                        <div class="sub-section text-muted">
                            <span>{{search.createdTime}} </span>
                            <span class="pull-left" style="padding-right:8px;">
                        		<i class="fas fa-info-circle pointMe" title="{{LOCALIZATION.viewDetails}}"></i>
                			</span>
                        </div>
                    </div>
                    <div class="col-sm-5 text-right primary-controls">
                        <button *ngIf="loggedin" 
                        	class="btn btn-sm btn-primary" 
                        	title="{{LOCALIZATION.saveSearch}}"
                            (click)="saveHistorySearch(search, $event);">
                            	<i class="fas fa-save" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-primary" 
                        	title="{{LOCALIZATION.searchClick}}"
                            (click)="executeHistorySearch(search, $event);">
                            	<i class="fas fa-search" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="well well-sm col-sm-12" style="word-wrap:break-word;">
                        <div>
                        	<span class="sub-label">{{LOCALIZATION.libraries}}: </span>
                        	<span>{{search.library}}</span>
                        </div>                                     
                        <div>
                        	<span class="sub-label">{{LOCALIZATION.type}}: </span>
                        	<span>{{search.type}}</span>
                        </div>
                        <div *ngFor="let c of search.criteria" class="truncate">
                            <span class="sub-label truncate">{{c.label}}: </span>
                            <span class="truncate" title="{{c.value}}">{{c.value}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!searchHistory || (searchHistory && searchHistory.length == 0)">
        <i>{{LOCALIZATION.searchHistoryEmpty}}</i>
    </div>
</div>
